import { apiConfig, createAxiosServiceInstance } from '../api';
import moment from 'moment';

import { convertToUtcTime, getValue } from '../../util/index';
import {
  dateFormat_DD_MM_YY,
  dateTimeFormat,
  MIN_FRACTION_DIGITS
} from '../../util/GlobalConstant';
import {
  getAlertStatus,
  getFormattedDate,
  getInvestigationResult,
  getSTR,
  isEmptyNullUndef
} from '../util';
import { find, startCase } from 'lodash';
import { getMatchedFeatureValue } from '../../pages/tm/investigationDetail/Explainability';
import {
  AMLS_NS_SAM,
  AMLS_TM_COMMON,
  AMLS_TM_SAM
} from '../../pages/constants/globalConstants';
import { convertDateInputToEpoch } from '../../util/timezone';

const axios = createAxiosServiceInstance();
const tmBaseUrl = `${apiConfig.serviceApi}${AMLS_TM_SAM}`;
const nsBaseUrl = `${apiConfig.serviceApi}${AMLS_NS_SAM}`;
const alertsBaseUrl = `${tmBaseUrl}/alerts`;
const customerBaseUrl = `${apiConfig.serviceApi}${AMLS_TM_COMMON}/customers`;
const saved_token = (localStorage && localStorage.getItem('id_token')) || '';
const productId = (localStorage && localStorage.getItem('productId')) || '';
const headers = {
  'Content-Type': 'application/json',
  'X-HTTP-Method-Override': 'PUT',
  Authorization: `${saved_token}`,
  ProductId: productId
};

const PREDICTION = 'PREDICTION';
const GROUP = 'GROUP';
const RED_FLAG = 'RED_FLAG';
const FEATURE = 'FEATURE';

export async function getAlertDetail(payload) {
  const { id } = payload;
  const url = `${apiConfig.serviceApi + AMLS_TM_COMMON}/alerts/${id}`;
  return await axios
    .get(url, { headers })
    .then((res) => {
      if (res.data !== '') {
        const {
          details: {
            alertId,
            clusterId,
            primaryPartyKey,
            alertType,
            alertDate,
            referenceDate,
            alertLevel,
            alertScore,
            alertStatus,
            accountId,
            isIssue,
            investigationResult,
            modelId,
            isStr,
            rules,
            supervisorNote,
            nextActions,
            analystName,
            investigatorNote,
            attachmentId,
            attachmentName
          }
        } = res.data;

        return {
          agree: false,
          alert_id: alertId,
          alertDate: moment
            .utc(alertDate, [dateTimeFormat])
            .local()
            .format('DD/MM/YYYY'),
          referenceDate: moment
            .utc(referenceDate || alertDate, [dateTimeFormat])
            .local()
            .format('DD/MM/YYYY'),
          originalReferenceDate: referenceDate,
          clusterId,
          modelId,
          isIssue,
          pendingAgreement: true,
          prediction: '',
          score: alertScore,
          account_id: accountId,
          investigation_result: investigationResult,
          str_sar_filed: isStr,
          alert_level: alertLevel,
          customer_id: primaryPartyKey,
          alert_type: alertType === 0 ? 'ALERT' : 'ANOMALY',
          alertStatus,
          rules,
          supervisorNote,
          investigatorNote,
          nextActions,
          analystName,
          attachmentId,
          attachmentName,
          originalAlertDetailData: res.data
        };
      } else return {};
    })
    .catch((err) => {
      console.log('Error :', err);
    });
}

export async function postCloseAlert(payload) {
  const url = `${alertsBaseUrl}/${alertId}`;

  return await axios.put(url, isIssue, { headers }).then((res) => {
    const {
      alertId,
      clusterId,
      primaryPartyKey,
      alertType,
      alertLevel,
      alertScore,
      alertStatus,
      accountId,
      investigationResult,
      modelId,
      isStr,
      isIssue,
      rules,
      supervisorNote,
      nextActions,
      analystName
    } = res.data;

    return {
      agree: false,
      alert_id: alertId,
      clusterId,
      modelId,
      isIssue,
      pendingAgreement: true,
      prediction: '',
      score: alertScore,
      account_id: accountId,
      investigation_result: investigationResult,
      str_sar_filed: isStr,
      alert_level: alertLevel,
      customer_id: primaryPartyKey,
      alert_type: alertType === 0 ? 'ALERT' : 'ANOMALY',
      alertStatus,
      supervisorNote,
      nextActions,
      analystName,
      rules,
      originalAlertDetailData: res.data
    };
  });
}

export async function getClusterInformation(payload) {
  const { clusterId } = payload;

  const url = `${tmBaseUrl}/clusters/${clusterId}`;
  return await axios.get(url, { headers }).then((res) => {
    return res.data;
  });
}

export async function getCustomerProfile(payload) {
  const { alert_id, customer_id } = payload;

  const url = `${customerBaseUrl}`;
  const params = {
    alertId: alert_id,
    customerId: customer_id
  };

  return await axios.get(url, { headers, params }).then((res) => {
    const {
      partyName, //
      riskRating, //
      customerType,
      age,
      dobOrIncorporationDate,
      nationality,
      domicileCountry,
      city,
      isStaff,
      postalCode,
      segment,
      occupation,
      residentialAddress,
      gender,
      isPep,
      highRiskPartyInfo,
      employerTypeOfBusiness,
      alertId,
      division,
      documentType,
      nationalityCode,
      contactNumber,
      isPrimary,
      documentId,
      activityDetailsTxnAdditionalInfo,
      documentIssueCountry,
      employerName,
      activityDetailsTxnByType,
      annualTurnover,
      product,
      partyKey,
      birthIncorporationCountry,
      residenceOperationCountry,
      citizenshipCountry,
      designation
    } = res.data;

    return {
      customer_id,
      current_alert_account_id: alert_id,
      customer_name: partyName,
      risk_rating: riskRating,
      type: customerType,
      age,
      dob: dobOrIncorporationDate
        ? moment
            .utc(dobOrIncorporationDate, [dateTimeFormat])
            .local()
            .format('DD/MM/YYYY')
        : '',
      gender,
      citizenship: nationality,
      domicile_country: domicileCountry,
      isStaff,
      city,
      occupation: occupation,
      segment,
      ns_link: false,
      postal_code: postalCode,
      residential_address: residentialAddress,
      str_count: 0,
      alert_count: 0,
      isPep: isPep,
      high_risk_party_info: highRiskPartyInfo,
      employer_typeof_business: employerTypeOfBusiness,
      alert_id: alertId,
      division,
      document_type: documentType,
      nationality_code: nationalityCode,
      contact_number: contactNumber,
      is_primary: isPrimary,
      document_id: documentId,
      activityDetailsTxnAdditionalInfo,
      document_issue_country: documentIssueCountry,
      employer_name: employerName,
      activityDetailsTxnByType,
      annual_turnover: annualTurnover,
      product,
      party_key: partyKey,
      birthIncorporationCountry,
      residenceOperationCountry,
      citizenship_country: citizenshipCountry,
      designation
    };
  });
}

export async function getCustomerAsssociatedAccounts(payload) {
  const { alert_id, customer_id } = payload;

  const url = `${customerBaseUrl}/${customer_id}/accounts`;
  const params = {
    alertId: alert_id
    // customerId: customer_id,
  };

  return await axios.get(url, { headers, params }).then((res) => {
    const listOfAssociatedAccounts = res.data;

    // looping to correspond to existing format
    return listOfAssociatedAccounts.map((o) => {
      const {
        accountId, // Account ID
        accountCurrency,
        c2aRelationship,
        accountName,
        alertId,
        balance,
        accountStatus,
        accountDrAvgBalance,
        accountCrAvgBalance,
        relatedParty,
        product,
        cardNumber,
        loanInstallmentAmount,
        loanGlGroup,
        loanGroup,
        loanPurposeCode,
        loanAmount,
        loanType,
        numberOfRepayments,
        totalRepaidAmount,
        creditLimit,
        fdReceiptNumber,
        fdOriginalAmount,
        outstandingLoanBalance,
        alertedAccount
      } = o || {};

      let {
        openDate,
        accountClosedDate,
        fdPlacementDate,
        fdWithdrawalDate,
        fdMaturityDate,
        loanMaturityDate,
        loanDisbursementDate
      } = o || {};

      openDate = getFormattedDate(openDate, dateFormat_DD_MM_YY);
      accountClosedDate = getFormattedDate(
        accountClosedDate,
        dateFormat_DD_MM_YY
      );
      fdPlacementDate = getFormattedDate(fdPlacementDate, dateFormat_DD_MM_YY);
      fdWithdrawalDate = getFormattedDate(
        fdWithdrawalDate,
        dateFormat_DD_MM_YY
      );
      fdMaturityDate = getFormattedDate(fdMaturityDate, dateFormat_DD_MM_YY);
      loanMaturityDate = getFormattedDate(
        loanMaturityDate,
        dateFormat_DD_MM_YY
      );
      loanDisbursementDate = getFormattedDate(
        loanDisbursementDate,
        dateFormat_DD_MM_YY
      );

      return {
        account_id: getValue(accountId),
        isAlertedAccount: alertedAccount,
        account_currency: getValue(accountCurrency),
        c2a_relationship: getValue(c2aRelationship),
        account_name: getValue(accountName),
        alert_id: getValue(alertId),
        balance: balance,
        account_status: getValue(accountStatus),
        account_dr_avg_balance: accountDrAvgBalance,
        account_cr_avg_balance: accountCrAvgBalance,
        account_open_date: getValue(openDate),
        account_closed_date: getValue(accountClosedDate),
        related_party: getValue(relatedParty),
        product: getValue(product),
        card_number: getValue(cardNumber),
        loan_disbursement_date: getValue(loanDisbursementDate),
        loan_installment_amount: loanInstallmentAmount,
        loan_gl_group: getValue(loanGlGroup),
        loan_group: getValue(loanGroup),
        loan_purpose_code: getValue(loanPurposeCode),
        loan_maturity_date: getValue(loanMaturityDate),
        loan_amount: loanAmount,
        loan_type: getValue(loanType),
        number_of_repayments: getValue(numberOfRepayments),
        total_repaid_amount: totalRepaidAmount,
        credit_limit: creditLimit,
        fd_receipt_number: getValue(fdReceiptNumber),
        fd_placement_date: getValue(fdPlacementDate),
        fd_withdrawal_date: getValue(fdWithdrawalDate),
        fd_maturity_date: getValue(fdMaturityDate),
        fd_original_amount: fdOriginalAmount,
        outstanding_loan_balance: outstandingLoanBalance
      };
    });
  });
}

export async function getCustomerAlertHistory(payload) {
  const {
    alert_id,
    alertId,
    customer_id,
    customerId,
    to,
    from,
    offset,
    limit,
    filterPayload,
    isScrolled
  } = payload;

  const url = `${customerBaseUrl}/${customer_id || customerId}/alertHistory`;
  const params = {
    ...filterPayload,
    alertId: alert_id || alertId,
    customerId: customer_id || customerId,
    to: to
      ? to
      : filterPayload?.to
      ? convertDateInputToEpoch(filterPayload.to, true)
      : convertDateInputToEpoch(moment(), true),
    from: from
      ? from
      : convertDateInputToEpoch(
          moment().subtract(1, 'months').add(1, 'days'),
          true
        ),
    from: from
      ? from
      : filterPayload?.from
      ? convertDateInputToEpoch(filterPayload.from, false)
      : convertDateInputToEpoch(
          moment().subtract(1, 'months').add(1, 'days'),
          true
        ),
    q: '',
    limit: limit || 10,
    offset: offset || 0
  };

  return await axios.get(url, { headers, params }).then((res) => {
    const listOfAlertHistory = res.data;
    const listOfAlerts = listOfAlertHistory.map((o) => {
      const {
        details: {
          account,
          accountCurrency,
          alertId,
          alertDate,
          alertSourceId,
          primaryPartyKey,
          primaryPartyName,
          isIssue,
          alertType,
          alertStatus,
          rules,
          alertLevel,
          alertScore,
          segmentName,
          segmentCode,
          accountId,
          accountType,
          accountOpenDate,
          hitsScore,
          alertAge,
          clusterId,
          clusterScore,
          analystName,
          closureDate,
          investigationResult,
          isStr
        },
        account: { c2aRelationship }
      } = o;

      let alert_status = getAlertStatus(alertStatus);

      return {
        alertId: getValue(alertId),
        closureDate:
          closureDate && alertStatus == 1
            ? moment
                .utc(closureDate, [dateTimeFormat])
                .local()
                .format('DD/MM/YYYY')
            : '-',
        str: getValue(isStr),
        isIssue: getValue(isIssue),
        investigationResult: getInvestigationResult(
          alertStatus,
          isStr,
          isIssue,
          investigationResult
        ),
        accountId: getValue(accountId),
        isPrimaryOwner: false,
        alertDate: alertDate
          ? moment.utc(alertDate, [dateTimeFormat]).local().format('DD/MM/YYYY')
          : '-',
        rules,
        isScrolled,
        alertSourceId,
        primaryPartyKey,
        primaryPartyName,
        alertType: alertSourceId === '0' ? 'ALERT' : 'ANOMALY',
        alertStatus: alert_status,
        alertLevel: getValue(alertLevel),
        alertScore: getValue(alertScore),
        segmentName: getValue(segmentName),
        segmentCode,
        accountType,
        accountOpenDate,
        hitsScore,
        alertAge,
        clusterId,
        clusterScore,
        analystName,
        accountCurrency,
        isStr: getSTR(alertStatus, isStr)
      };
    });

    return {
      alert_list: listOfAlerts,
      isScrolled
    };
  });
}

export async function getCustomerTransactionHistory(payload) {
  const {
    alert_id,
    alertId,
    customer_id,
    customerId,
    to,
    from,
    offset,
    limit,
    isScrolled,
    transactionType,
    highRiskCountryFlag,
    referenceDate,
    referenceDateSubtractDays,
    isReferenceDateUsed,
    channelInfo
  } = payload;

  const url = `${customerBaseUrl}/${
    customer_id || customerId
  }/transactionHistory`;
  let params = {
    alertId: alert_id || alertId,
    to: to ? to : convertDateInputToEpoch(moment(), true),
    from: from
      ? from
      : convertDateInputToEpoch(
          moment().subtract(1, 'months').add(1, 'days'),
          true
        ),
    q: '',
    limit: limit || 20,
    offset: offset || 0
  };

  if (isReferenceDateUsed) {
    params['to'] = moment(referenceDate, [
      'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
    ]).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    params['from'] = moment(referenceDate, ['YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'])
      .subtract(referenceDateSubtractDays, 'days')
      .format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
  }

  // if payload has filter
  if (payload.filter) {
    params = {
      ...payload.filter,
      to,
      from,
      limit: limit || 20,
      offset: offset || 0
    };
  }

  if (
    !isEmptyNullUndef(transactionType) &&
    transactionType.toUpperCase() !== 'TOTAL'
  ) {
    if (transactionType.toUpperCase().includes('_DAILY')) {
      const numberOfDays = 1;
      const toDate = params.to;
      params = {
        ...params,
        transactionType: `${channelInfo ? channelInfo.channelType : '-'}`,
        from
      };
    } else if (transactionType.toUpperCase().includes('DAY')) {
      // split array by underscores
      const featureArray = transactionType.split('_');
      // get the item with the number of days
      const stringDays = featureArray[1] || null;

      if (stringDays) {
        // parse number of days from string
        const numberOfDays = Number(
          stringDays.toUpperCase().replace('DAY', '')
        );
        const toDate = params.to;
        params = {
          ...params,
          transactionType: `${channelInfo ? channelInfo.channelType : '-'}`,
          from
        };
      }
    } else {
      if (transactionType.toUpperCase() === 'CARD-PAYMENT') {
        params = {
          ...params,
          transactionType: '[card-payment,cash-equivalent-card-payment]'
        };
      } else {
        params = {
          ...params,
          transactionType: `[${transactionType}]`
        };
      }
    }
  }

  if (!isEmptyNullUndef(highRiskCountryFlag)) {
    params = {
      ...params,
      highRiskCountryFlag
    };
  }

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      // go through each record to format and serve for better integration
      const listOfTransactions = res.data?.payload;
      if (Array.isArray(listOfTransactions)) {
        const formattedTransactions = listOfTransactions.map((o) => {
          const {
            beneficiary,
            localCurrencyEquivalent,
            transactionCurrency,
            isCredit,
            transactionDate,
            destCountryCode,
            id,
            accountId,
            amount,
            transactionTypeDescription,
            branchBankCode,
            chequeNo,
            swiftMsgType,
            trancheNo,
            remittancePaymentDetails,
            creditCardNumber,
            creditLimit,
            originatorAddress,
            beneficiaryAddress,
            atmLocation,
            tellerId,
            countryOfTransaction,
            atmId,
            tdNumber,
            mcc,
            originatorBankCountryCode,
            yourReference,
            isPrimary,
            bankInfo,
            merchantName,
            originator,
            counterParty,
            beneficiaryBankCountryCode,
            swiftMsgInfo,
            ourReference,
            remittanceCountry,
            transactionTypeCode,
            productCode,
            partyKey,
            accountCurrency,
            transactionCurrencyAmount,
            mccMerchantName
          } = o;

          return {
            beneficiary,
            amount,
            transactionCurrency,
            credit_debit:
              isCredit == undefined || isCredit == null
                ? null
                : isCredit
                ? 'CR'
                : 'DR',
            date: transactionDate,
            destination: destCountryCode,
            id,
            source: `${accountId}`,
            type: transactionTypeDescription,
            branchBankCode,
            chequeNo,
            swiftMsgType,
            trancheNo,
            remittancePaymentDetails,
            creditCardNumber,
            creditLimit,
            originatorAddress,
            beneficiaryAddress,
            atmLocation,
            tellerId,
            countryOfTransaction,
            atmId,
            tdNumber,
            mcc,
            originatorBankCountryCode,
            yourReference,
            isPrimary,
            bankInfo,
            merchantName,
            originator,
            counterParty,
            beneficiaryBankCountryCode,
            swiftMsgInfo,
            ourReference,
            remittanceCountry,
            transactionTypeCode,
            productCode,
            partyKey,
            accountCurrency,
            mccMerchantName,
            transactionCurrencyAmount,
            localCurrencyEquivalent
          };
        });

        return {
          alert_id: alert_id || alertId,
          associated_transactions: formattedTransactions,
          isScrolled,
          customerId: customer_id || customerId
        };
      }

      return {
        alert_id: alert_id || alertId,
        associated_transactions: [],
        isScrolled,
        customerId: customer_id || customerId
      };
    })
    .catch((err) => {
      throw {
        message: 'Cannot fetch transactions at this time'
      };
    });
}

export async function getModelExplainability(payload) {
  const { alert_id, featureCodes, featureTypes } = payload;

  const url = `${apiConfig.serviceApi}${AMLS_TM_COMMON}/alerts/${alert_id}/modelExplainability`;

  return await axios.get(url, { headers }).then((res) => {
    const { groups } = res.data;
    let tabularExplainabilityData = [];

    const models = groups.map((group) => {
      const currentGroup = {
        name: `Group ${group.name}`,
        _collapsed: true,
        attributes: {
          CONTRIBUTION: group.contribution
        },
        type: GROUP,
        nodeSvgShape: {
          shape: 'none'
        }
      };

      // loop through typologies of the current group
      currentGroup['children'] = group.typology.map((typology) => {
        const currentTypology = {
          name: typology.name,
          _collapsed: true,
          attributes: {
            RED_FLAG_CONTRIBUTION: typology.contribution
          },
          type: RED_FLAG,
          nodeSvgShape: {
            shape: 'none'
          }
        };

        const featureCount = typology.features.length;

        // loop through each features of the current typology
        currentTypology['children'] = typology.features.map((feature, idx) => {
          let featureName = null;
          if (Array.isArray(featureCodes) && featureCodes.length > 0) {
            featureCodes.forEach((featureCode) => {
              if (feature.name === featureCode.code) {
                featureName = featureCode.description;
              }
            });
          }

          let tabularFeatureData = null;

          if (idx === 0) {
            tabularFeatureData = {
              redFlag: typology.name,
              feature: featureName ? featureName : feature.name,
              featureCount,
              featureContribution: feature.contribution,
              featureValue: feature.featureValue
            };
          } else {
            tabularFeatureData = {
              feature: featureName ? featureName : feature.name,
              featureContribution: feature.contribution,
              featureValue: feature.featureValue
            };
          }

          tabularExplainabilityData.push(tabularFeatureData);
          const featureType = find(featureTypes, { code: feature.name });
          const { description = '-' } = featureType || {};
          const { value: featureValue } = getMatchedFeatureValue(
            feature.featureValue,
            description,
            '-'
          );
          return {
            name: featureName ? startCase(featureName) : feature.name,
            type: FEATURE,
            attributes: {
              CONTRIBUTION: feature.contribution,
              VALUE: featureValue
            }
          };
        });

        return currentTypology;
      });

      return currentGroup;
    });
    return {
      treeView: [
        {
          name: 'PREDICTION',
          attributes: {
            LEVEL: 'L3'
          },
          nodeSvgShape: {
            shape: 'none'
          },
          children: [...models]
        }
      ],
      tabularView: tabularExplainabilityData,
      featureViewData: groups
    };
  });
}

/**
 * This is not in use, will be used in the future
 * @param {object} payload
 */
export async function getHistAlertHeader(payload) {
  return {};
}

export async function getHistAlert(payload) {
  const { alertId, from, to, limit, offset, str, result, rule, customers } =
    payload;

  let url = `/tm/sam/alerts/${alertId}/history?
    limit=${limit ? limit : 10}&offset=${offset ? offset : 0}${
    from ? '&from=' + from : ''
  }${to ? '&to=' + to : ''}
    ${str ? '&str=' + str : ''}${result ? '&result=' + result : ''}${
    rule ? '&rules=' + rule : ''
  }${customers ? '&customers=' + customers : ''}`.replace(/ /g, '');

  return await axios.get(url);
}

export async function getRiskIndicators() {
  let url = `${tmBaseUrl}/riskIndicators`;

  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getCountries() {
  let url = `${tmBaseUrl}/countries`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getFeatureCodes() {
  let url = `${tmBaseUrl}/codes?codeType=FEATURE_DESCRIPTION_CODE`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getFeatureTypeIdentifiers() {
  let url = `${tmBaseUrl}/codes?codeType=FEATURE_TYPE_IDENTIFIER`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getTransactionProductMapping() {
  let url = `${tmBaseUrl}/codes?codeType=TRANSACTION_PRODUCT_MAPPING`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getClusterViewDescription() {
  let url = `${tmBaseUrl}/codes?codeType=CLUSTER_VIEW_DESCRIPTION`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getFeatureCategoryCodes() {
  let url = `${tmBaseUrl}/codes?codeType=FEATURE_CATEGORY_CODE`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

export async function getTransactionTypes() {
  let url = `${tmBaseUrl}/codes`;
  const params = {
    codeType: 'TRANSACTION_TYPE'
  };

  return await axios.get(url, { params }).then((res) => {
    return {
      data: res.data
    };
  });
}

//?ids=C11,c22
// TM generated alerts count for customer
export async function getTMGeneratedAlertCount(queryString) {
  const url = `${customerBaseUrl}/alertCount?customerIds=${queryString}`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}

// TM generated alerts count for customer
export async function getNSGeneratedAlertCount(queryString) {
  const url = `${nsBaseUrl}/customers/alertCount?customerIds=${queryString}`;
  return await axios.get(url);
  return await axios
    .get(url)
    .then((res) => {
      return {
        data: res.data
      };
    })
    .catch(() => {
      return {
        data: []
      };
    });
}

export async function getRiskIndicatorsGraph(payload) {
  const { clusterId, alert_id, customer_id, modelId } = payload;

  const url = `${customerBaseUrl}/${customer_id}/riskIndicatorGraph`;
  const params = {
    alertId: alert_id,
    modelId,
    clusterId
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data.map((graphData) => {
        const {
          profileDeviationGraph,
          peerComparisonGraph,
          importance,
          riskIndicatorId
        } = graphData;

        let selfComparisonCurrentValue = null;
        const selfComparisonDataPoints = profileDeviationGraph[
          'distribution'
        ].map((o) => {
          if (o.range === 'T0') {
            selfComparisonCurrentValue = {
              date: 'T0 (Current)',
              value: o.value !== 'nan' ? Number(o.value) : 0
            };

            return {
              date: 'T0 (Current)',
              value: o.value !== 'nan' ? Number(o.value) : 0
            };
          }

          return {
            date: o.range,
            value: o.value !== 'nan' ? Number(o.value) : 0
          };
        });

        let customerDotIndex = null;
        const peerComparisonDataPoints = peerComparisonGraph[
          'distribution'
        ].map((o, idx) => {
          let range = 0;
          if (o.range !== 'nan') {
            const arrayOfY = o.range
              .replace('(', '')
              .replace(')', '')
              .split(',');
            let sumOfY = 0;
            arrayOfY.map((y) => {
              sumOfY += Number(y);
            });
            range = sumOfY / arrayOfY.length;

            if (arrayOfY.length === 1) {
              if (arrayOfY[0] === peerComparisonGraph['riValue']) {
                customerDotIndex = idx;
              }
            }

            if (arrayOfY.length > 1) {
              if (
                arrayOfY[1] >= peerComparisonGraph['riValue'] &&
                peerComparisonGraph['riValue'] >= arrayOfY[0]
              ) {
                customerDotIndex = idx;
              }
            }
          }
          return {
            count: o.range,
            value: o.value !== 'nan' ? Number(o.value) : 0
          };
        });

        return {
          riskIndicatorId,
          importance: !isNaN(importance)
            ? Number(importance).toFixed(MIN_FRACTION_DIGITS)
            : 0,
          self_comparision: {
            mean: profileDeviationGraph['mean'],
            deviation: profileDeviationGraph['deviation'],
            current_value: selfComparisonCurrentValue,
            title: 'Value over period',
            data_points: selfComparisonDataPoints
          },
          peer_comparison: {
            mean: peerComparisonGraph['mean'],
            deviation: peerComparisonGraph['deviation'],
            percentile: `${Number(
              peerComparisonGraph['percentile'] * 100
            ).toFixed(MIN_FRACTION_DIGITS)}%`,
            title: 'Value distribution',
            current_value: {
              riValue: peerComparisonGraph['riValue']
            },
            data_points: peerComparisonDataPoints
          }
        };
      });
    })
    .catch((err) => {
      throw {
        message: 'Please try again'
      };
    });
}

export async function getC2CLinkedCustomers(payload) {
  const { alert_id, alertId, customer_id, customerId, offset, limit } = payload;

  const url = `${customerBaseUrl}/${customer_id || customerId}/linkedCustomers`;
  let params = {
    alertId: alert_id || alertId,
    customerId: customer_id || customerId,
    limit: limit || 20,
    offset: offset || 0
  };
  const c2cData = await axios
    .get(url, { headers, params })
    .then((res) => {
      const { data } = res || {};
      if (data) {
        const { list = [], totalCount = 0 } = data;
        if (totalCount === 0) {
          return {
            alert_id: alert_id || alertId,
            customerId: customer_id || customerId,
            linked_c2c_accounts: []
          };
        } else {
          const formattedLinkedAccounts = list.map((o) => {
            const {
              shareholderPercentage,
              city,
              highRiskPartyInfo,
              partyName,
              primaryPartyKey,
              residentialAddress,
              riskRating,
              domicileCountry,
              alertId,
              customerType,
              age,
              segment,
              division,
              postalCode,
              relationType,
              linkedPartyKey,
              nationality,
              nationalityCode,
              isPrimary,
              occupation,
              relationDescription,
              dobOrIncorporationDate,
              product,
              gender,
              maskApplied
            } = o;
            let formattedShareholderPerc = '';
            if (
              shareholderPercentage != null &&
              !isNaN(shareholderPercentage)
            ) {
              formattedShareholderPerc = `${Number.parseFloat(
                shareholderPercentage
              ).toFixed(MIN_FRACTION_DIGITS)}%`;
            }
            return {
              shareholderPercentage: formattedShareholderPerc,
              city,
              highRiskPartyInfo,
              partyName,
              primaryPartyKey,
              residentialAddress,
              riskRating,
              domicileCountry,
              alertId,
              customerType,
              age,
              segment,
              division,
              postalCode,
              relationType,
              linkedPartyKey,
              nationality,
              nationalityCode,
              isPrimary,
              occupation,
              relationDescription,
              dobOrIncorporationDate: dobOrIncorporationDate
                ? moment(dobOrIncorporationDate).format(dateFormat_DD_MM_YY)
                : '-',
              product,
              gender,
              maskApplied,
              tm_alert_count: 0,
              ns_alert_count: 0
            };
          });

          return {
            alert_id: alert_id || alertId,
            customerId: customer_id || customerId,
            linked_c2c_accounts: formattedLinkedAccounts
          };
        }
      }

      return {
        alert_id: alert_id || alertId,
        customerId: customer_id || customerId,
        linked_c2c_accounts: []
      };
    })
    .catch((err) => {
      throw {
        message: 'Cannot fetch linked accounts at this time'
      };
    });

  let queryString = '';
  c2cData.linked_c2c_accounts.map((row) => {
    queryString += `${row['linkedPartyKey']},`;
  });

  const { data: tmCountData } = await getTMGeneratedAlertCount(queryString);
  const { data: nsCountData } = await getNSGeneratedAlertCount(queryString);

  c2cData.linked_c2c_accounts.map((row) => {
    tmCountData.map((data) => {
      if (data.customerId === row.linkedPartyKey) {
        row['tm_alert_count'] = data.count;
      }
    });
    nsCountData.map((data) => {
      if (data.customerId === row.linkedPartyKey) {
        row['ns_alert_count'] = data.count;
      }
    });
  });
  return c2cData;
}

const getParamsFromPayload = (payload) => {
  const anomalyActionConfig = {
    reassign: {
      params: ['analystName'],
      currentStatus: 0,
      expectedStatus: 2,
      endpoint: 'reassign'
    },
    reopen: {
      params: [],
      currentStatus: 0,
      expectedStatus: 2,
      endpoint: 'reopen'
    },
    assign: {
      params: ['analystName'],
      currentStatus: 0,
      expectedStatus: 2,
      endpoint: 'assign'
    },
    approve: {
      params: ['supervisorNote'],
      currentStatus: 4,
      expectedStatus: 1,
      endpoint: 'approveInvestigation'
    },
    reject: {
      params: ['supervisorNote'],
      currentStatus: 4,
      expectedStatus: 2,
      endpoint: 'rejectInvestigation'
    },
    analystWork: {
      params: ['investigatorNote', 'attachmentId', 'attachmentName'],
      currentStatus: 2,
      expectedStatus: 3,
      endpoint: 'saveInvestigatorNote'
    },
    supervisorWork: {
      params: ['supervisorNote'],
      currentStatus: 2,
      expectedStatus: 3,
      endpoint: 'saveSupervisorNote'
    },
    submit: {
      params: [
        'investigationResult',
        'investigatorNote',
        'attachmentId',
        'attachmentName'
      ],
      currentStatus: 3,
      expectedStatus: 4,
      endpoint: 'submitInvestigation'
    }
  };

  const { type } = payload;
  const { params, endpoint } = anomalyActionConfig[type];
  const paramMap = {};
  params.map((param) => {
    if (payload[param]) {
      paramMap[param] = payload[param];
    }
  });
  return {
    paramMap,
    endpoint
  };
};

export async function refreshAnomalyState(payload) {
  const { paramMap, endpoint } = getParamsFromPayload(payload);
  const { alertID } = payload;
  const url = `${apiConfig.serviceApi}${AMLS_TM_COMMON}/alerts/${alertID}/${endpoint}`;
  return await axios.put(url, { ...paramMap }).then((res) => {
    const {
      alertId,
      clusterId,
      primaryPartyKey,
      alertType,
      alertDate,
      alertLevel,
      alertScore,
      alertStatus,
      accountId,
      isIssue,
      investigationResult,
      modelId,
      isStr,
      rules,
      supervisorNote,
      nextActions,
      analystName,
      investigatorNote,
      attachmentId,
      attachmentName
    } = res.data;

    return {
      agree: false,
      alert_id: alertId,
      alertDate: moment
        .utc(alertDate, [dateTimeFormat])
        .local()
        .format('DD/MM/YYYY'),
      clusterId,
      modelId,
      isIssue,
      pendingAgreement: true,
      prediction: '',
      score: alertScore,
      account_id: accountId,
      investigation_result: investigationResult,
      str_sar_filed: isStr,
      alert_level: alertLevel,
      customer_id: primaryPartyKey,
      alert_type: alertType === 0 ? 'ALERT' : 'ANOMALY',
      alertStatus,
      rules,
      supervisorNote,
      investigatorNote,
      nextActions,
      analystName,
      attachmentId,
      attachmentName,
      originalAlertDetailData: res.data
    };
  });
}

export async function uploadFileToServer(data, uploadProgress) {
  const url = `${tmBaseUrl}/files`;
  return await axios
    .post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (ProgressEvent) => {
        uploadProgress(ProgressEvent);
      }
    })
    .then((res) => {
      // then print response status
      return res;
    })
    .catch((err) => {
      // then print response status
      return err;
    });
}

export async function getFileFromServer(fileID) {
  const url = `${tmBaseUrl}/files/${fileID}`;
  return await axios
    .get(url, {
      responseType: 'blob',
      timeout: 60000
    })
    .then((res) => {
      // then print response status
      return res;
    })
    .catch((err) => {
      // then print response status
      return err;
    });
}

export async function getListOfAnalysts(payload) {
  const limit = 100;
  const offset = 0;
  const url = `${tmBaseUrl}/hierarchy/analysts?limit=${limit}&offset=${offset}`;
  return await axios.get(url).then((res) => {
    return {
      data: res.data
    };
  });
}
